import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ErrorService } from '../../error';
import { ProductCategoryModel } from './types';
import { catchError } from 'rxjs/operators';
import { ListItem } from '../typeahead/types';

@Injectable({
  providedIn: 'root',
})
export class ProductCategoryApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
  ) {}

  getById = (id: number): Observable<ProductCategoryModel> => {
    let parameters: string[];
    parameters = [id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ProductCategoryModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  createInstance = (): Observable<ProductCategoryModel> => {
    let parameters: string[];
    parameters = ['create'];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ProductCategoryModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };
  add = (
    productCategoryModel: ProductCategoryModel,
  ): Observable<ProductCategoryModel> => {
    let parameters: string[];
    parameters = [];
    let url = this.formatUrl(parameters);
    return this.httpClient
      .post<ProductCategoryModel>(url, productCategoryModel)
      .pipe(
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  update = (
    productCategoryModel: ProductCategoryModel,
  ): Observable<ProductCategoryModel> => {
    let parameters: string[];
    parameters = [productCategoryModel.id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient
      .put<ProductCategoryModel>(url, productCategoryModel)
      .pipe(
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  getList = (id: number): Observable<ListItem[]> => {
    let parameters: string[];
    parameters = ['list'];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ListItem[]>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.productcategory.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
